/* Portfolio lightbox: roomier "available on" cards (Sep 23).

   The gallery block fills [data-lightbox-available-row] with one card per
   linked product each time a drawing is shown. On a phone four or five cards
   were squeezed side by side and the product names cut off after one letter.

   Now each time the row is filled:
     1. every card starts small enough that the whole set fits on screen, so
        the visitor sees at a glance how many options there are;
     2. after a short pause the cards slowly widen (about two across on a
        phone), pushing the rest off the right edge;
     3. the row scrolls sideways, with a thin scrollbar and a soft fade on the
        edge that has more cards behind it, so it reads as scrollable.

   MORE-DESIGNS ARROW (Oct 5): when cards are hidden off the right edge, a
   small tan chevron in a dark circle sits over the right end of the row,
   gently nudging right. It disappears as soon as the visitor scrolls the row
   (or taps the arrow, which scrolls one card over) and comes back fresh for
   the next drawing. Drawings whose designs all fit on screen never show it.

   Each card also shows a few words about the product (the product's
   custom.card_description metafield, e.g. "Soft unisex tri-blend tee") in
   place of the price. The gallery renders the price line; this swaps its text
   for the description, matched by product URL. With no description set, the
   line is hidden rather than falling back to the price.

   Self-contained and keyed on data attributes, so it covers every portfolio
   gallery page without touching the gallery block itself. */
(function () {
  'use strict';

  var ROW = '[data-lightbox-available-row]';
  var SIDE_PADDING = 16; // px, matches the row padding below
  var GAP = 12; // px, matches the row gap below
  var PAUSE = 700; // ms the compact view is held before widening
  var ARROW = 30; // px, size of the more-designs arrow

  var css =
    '[data-lightbox] [data-lightbox-available]{left:0!important;right:0!important;transform:none!important;width:100%!important;max-width:none!important;}' +
    '[data-lightbox] ' + ROW + '{box-sizing:border-box!important;width:100%!important;max-width:none!important;gap:' + GAP + 'px!important;padding:4px ' + SIDE_PADDING + 'px 12px!important;overflow-x:auto!important;overscroll-behavior-x:contain;scroll-snap-type:x proximity;scroll-padding-inline:' + SIDE_PADDING + 'px;-webkit-overflow-scrolling:touch;scrollbar-width:thin!important;scrollbar-color:rgba(255,255,255,.45) transparent;}' +
    '[data-lightbox] ' + ROW + '::-webkit-scrollbar{display:block!important;height:4px;}' +
    '[data-lightbox] ' + ROW + '::-webkit-scrollbar-thumb{background:rgba(255,255,255,.45);border-radius:4px;}' +
    '[data-lightbox] ' + ROW + '>*{flex:0 0 var(--avail-card-w,220px)!important;min-width:0!important;box-sizing:border-box;scroll-snap-align:start;transition:flex-basis .8s cubic-bezier(.22,.61,.36,1),background .2s ease,transform .2s ease,box-shadow .2s ease;}' +
    '[data-lightbox] ' + ROW + '.is-compact>*{transition:none!important;}' +
    '[data-lightbox] ' + ROW + '>*:first-child{margin-left:auto;}' +
    '[data-lightbox] ' + ROW + '>*:last-child{margin-right:auto;}' +
    '[data-lightbox] ' + ROW + ' [class*="available-info"]{flex:1 1 auto;min-width:0;overflow:hidden;}' +
    '[data-lightbox] ' + ROW + ' [class*="available-title"]{max-width:none!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
    '[data-lightbox] ' + ROW + ' [class*="available-cta"]{white-space:nowrap;}' +
    '[data-lightbox] ' + ROW + ' .avail-desc{white-space:normal!important;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;line-height:1.25;opacity:.85!important;}' +
    '[data-lightbox] ' + ROW + ' .avail-desc[hidden]{display:none!important;}' +
    '[data-lightbox] ' + ROW + '.more-right{-webkit-mask-image:linear-gradient(to right,#000 82%,transparent);mask-image:linear-gradient(to right,#000 82%,transparent);}' +
    '[data-lightbox] ' + ROW + '.more-left{-webkit-mask-image:linear-gradient(to right,transparent,#000 18%);mask-image:linear-gradient(to right,transparent,#000 18%);}' +
    '[data-lightbox] ' + ROW + '.more-left.more-right{-webkit-mask-image:linear-gradient(to right,transparent,#000 12%,#000 82%,transparent);mask-image:linear-gradient(to right,transparent,#000 12%,#000 82%,transparent);}' +
    '[data-lightbox] .avail-more{position:absolute;right:max(8px,env(safe-area-inset-right));z-index:4;box-sizing:border-box;width:' + ARROW + 'px;height:' + ARROW + 'px;padding:0;margin:0;border:1px solid rgba(200,182,154,.45);border-radius:50%;background:rgba(0,0,0,.62);color:#c8b69a;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.5);opacity:0;visibility:hidden;pointer-events:none;transition:opacity .35s ease,visibility 0s linear .35s,background .2s ease,color .2s ease;-webkit-tap-highlight-color:transparent;touch-action:manipulation;}' +
    '[data-lightbox] .avail-more::before{content:"";position:absolute;inset:-9px;}' +
    '[data-lightbox] .avail-more.is-on{opacity:1;visibility:visible;pointer-events:auto;transition:opacity .35s ease,visibility 0s,background .2s ease,color .2s ease;}' +
    '[data-lightbox] .avail-more svg{width:15px;height:15px;display:block;animation:avail-more-nudge 1.6s ease-in-out infinite;}' +
    '[data-lightbox] .avail-more:hover{background:rgba(0,0,0,.85);color:#fff;}' +
    '[data-lightbox] .avail-more:focus-visible{outline:2px solid #c8b69a;outline-offset:2px;}' +
    '@keyframes avail-more-nudge{0%,100%{transform:translateX(-1px)}50%{transform:translateX(2px)}}' +
    '@media (prefers-reduced-motion: reduce){[data-lightbox] ' + ROW + '>*{transition:none!important;}[data-lightbox] .avail-more svg{animation:none;}}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function expandedWidth() {
    // About two cards across on a phone, a comfortable fixed size on desktop.
    return window.innerWidth < 750 ? Math.round(window.innerWidth * 0.44) : 240;
  }

  function compactWidth(count) {
    var room = window.innerWidth - SIDE_PADDING * 2 - GAP * (count - 1);
    return Math.min(expandedWidth(), Math.floor(room / count));
  }

  // Product URL -> short description, read from every gallery item's data.
  function descriptions() {
    var map = {};
    var items = document.querySelectorAll('[data-gallery-item][data-products]');
    for (var i = 0; i < items.length; i++) {
      var list;
      try { list = JSON.parse(items[i].dataset.products) || []; } catch (e) { continue; }
      for (var j = 0; j < list.length; j++) {
        if (list[j] && list[j].url) map[list[j].url] = list[j].desc || '';
      }
    }
    return map;
  }

  function describe(row) {
    var map = descriptions();
    var cards = row.querySelectorAll('a[href]');
    for (var i = 0; i < cards.length; i++) {
      var line = cards[i].querySelector('[class*="available-price"]');
      if (!line) continue;
      var desc = map[cards[i].getAttribute('href')] || '';
      line.textContent = desc;
      line.classList.add('avail-desc');
      line.hidden = !desc;
    }
  }

  // The arrow lives beside the row (not inside it) so the row's edge fade
  // doesn't fade the arrow out too. The row is the last thing in its panel,
  // so the arrow is lined up with the middle of the cards from the bottom.
  function arrowFor(row) {
    if (row._availArrow) return row._availArrow;
    var wrap = row.parentElement;
    if (!wrap) return null;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'avail-more';
    b.setAttribute('aria-label', 'Scroll to see more designs');
    b.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var card = row.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + GAP : row.clientWidth * 0.8;
      row._availScrolled = true;
      b.classList.remove('is-on');
      row.scrollBy({ left: step, behavior: 'smooth' });
    });
    wrap.appendChild(b);
    row._availArrow = b;
    return b;
  }

  function updateFade(row) {
    var max = row.scrollWidth - row.clientWidth;
    var moreRight = max > 4 && row.scrollLeft < max - 4;
    row.classList.toggle('more-left', row.scrollLeft > 4);
    row.classList.toggle('more-right', moreRight);

    var arrow = arrowFor(row);
    if (!arrow) return;
    // Row padding is 4px top / 12px bottom, so the cards' middle sits
    // (height - 16) / 2 + 12 above the bottom of the panel.
    var middle = (row.offsetHeight - 16) / 2 + 12;
    arrow.style.bottom = Math.max(0, Math.round(middle - ARROW / 2)) + 'px';
    arrow.classList.toggle('is-on', moreRight && !row._availScrolled);
  }

  function arrange(row) {
    clearTimeout(row._availTimer);
    row._availScrolled = false;
    var count = row.children.length;
    if (!count) {
      if (row._availArrow) row._availArrow.classList.remove('is-on');
      return;
    }
    describe(row);

    var compact = compactWidth(count);
    var wide = expandedWidth();

    row.classList.add('is-compact');
    row.style.setProperty('--avail-card-w', compact + 'px');
    row.scrollLeft = 0;
    void row.offsetWidth;
    row.classList.remove('is-compact');
    updateFade(row);

    if (wide <= compact) return; // already full size, nothing to grow

    row._availTimer = setTimeout(function () {
      row.style.setProperty('--avail-card-w', wide + 'px');
      setTimeout(function () { updateFade(row); }, 850);
    }, PAUSE);
  }

  function watch(row) {
    if (row._availWatched) return;
    row._availWatched = true;
    row.addEventListener('scroll', function () {
      if (row.scrollLeft > 4) row._availScrolled = true;
      updateFade(row);
    }, { passive: true });
    new MutationObserver(function () { arrange(row); }).observe(row, { childList: true });
    if (row.children.length) arrange(row);
  }

  function scan() {
    var rows = document.querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) watch(rows[i]);
  }

  // The lightbox markup is moved into <body> by the gallery once it starts,
  // so keep an eye out for it rather than assuming it exists yet.
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true });

  window.addEventListener('resize', function () {
    var rows = document.querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i]._availTimer) continue;
      rows[i].style.setProperty('--avail-card-w', expandedWidth() + 'px');
      updateFade(rows[i]);
    }
  });
})();
